module.exports = __webpack_public_path__ + "static/motivational-trainloop-3f487e2c66146d3fbe9e47d3974a27f1.jpg";